module.exports = __webpack_public_path__ + "static/img/02560_3.34f4f90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02560_3.jpg
// module id = CuoH
// module chunks = 1